import React from "react";
const current_date = new Date();
let copyright_year = current_date.getFullYear();
const CopyRight = () => {
  return (
    <footer>
      <div className="pull-left">
        <a href="#">Clean Your List</a> © {copyright_year} All Rights Reserved.
      </div>
      <div className="pull-right">
        <a target="_blank" href="https://www.mirabeltechnologies.com/about-us">
          About Us
        </a>{" "}
        |{" "}
        <a target="_blank" href="https://www.mirabeltechnologies.com/contact">
          Contact Us
        </a>{" "}
        |
        <a target="_blank" href="https://www.mirabeltechnologies.com/privacy-statement">
          {" "}
          Privacy and Terms
        </a>
      </div>
    </footer>
  );
};
export default CopyRight;



// WEBPACK FOOTER //
// ./src/components/CopyRight.js